<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load" class="align-items-center">
                    <b-col lg="2" sm="12" class="text-left">
                        <lg-form-const-select label="Situação:" v-model="form.situacao"
                            :options="form.optionsFilterSituacao" @change="load" />
                    </b-col>

                    <b-col lg="6" sm="12" class="text-left">
                        <lg-form-input v-model="form.descricao" label="Nº/Descrição:" />
                    </b-col>

                    <b-col lg="4" sm="12" class="text-right d-flex justify-content-end align-items-center">
                        <b-button id="search-button" class="ml-3 mr-4 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load()">
                            <b-tooltip :target="'search-button'" title="Localizar">
                            </b-tooltip>
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                        </b-button>

                        <b-button id="add-button" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            @click="showSubgrupoModal" variant="primary" v-if="addBtnVisible && temPrivilegioCriacao()">
                            <b-tooltip :target="'add-button'" title="Adicionar Novo..."></b-tooltip>
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                        </b-button>
                    </b-col>
                </b-form-row>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.subgrupos"
                    :fields="this.tableFields" :filter="filtro" :hover="true" show-empty
                    @row-dblclicked="subgrupoSelect">
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template v-slot:cell(migrarSubgrupo)="row">
                        <b-button :disabled="!temPrivilegioAlterarClasse()" :id="row.index + 'migrate-button'"
                            class="my-2" size="sm" pill variant="primary" @click="migrarSubgrupo(row.item)">
                            <b-icon icon="folder-symlink" />
                            <b-tooltip :target="row.index + 'migrate-button'" title="Migrar Subgrupo..."></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(local)="row">

                        <b-button :disabled="!temPrivilegioLocalProibido()" :id="row.index + 'proibido-subgrupo-button'"
                            class="my-2" size="sm" pill variant="primary" @click="clickMostrarModalProibido(row.item)">
                            <b-icon icon="x-circle-fill" />
                            <b-tooltip :target="row.index + 'proibido-subgrupo-button'"
                                title="Locais Proibidos..."></b-tooltip>
                        </b-button>

                    </template>

                    <template v-slot:cell(editar)="row">


                        <b-button :disabled="!temPrivilegioEdicao()" :id="row.index + 'edit-button'" class="my-2"
                            size="sm" pill variant="primary" @click="editarSubgrupo(row.item)">
                            <b-icon icon="pencil-square" />
                            <b-tooltip :target="row.index + 'edit-button'" title="Editar..."></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(configuracoes)="row">
                        <b-button :id="row.index + 'configurar'" class="my-2" size="sm" pill variant="primary"
                            @click="configurarSubgrupo()">
                            <b-icon icon="gear" />
                            <b-tooltip :target="row.index + 'configurar'"
                                title="Configurar características..."></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(situacao)="row">
                        <div :id="row.index + 'switch'">
                            <b-form-checkbox :disabled="!temPrivilegioEdicao()" v-model="row.item.situacao"
                                @change="alteraSituacao(row.item)" name="check-button" switch size="lg" :value="1"
                                :unchecked-value="0" />
                            <b-tooltip :target="row.index + 'switch'" title="Ativar/Desativar..."></b-tooltip>
                        </div>
                    </template>

                    <template v-slot:cell(classe)="row">
                        <b-button :id="row.index + 'classe'" class="my-2" size="sm" pill variant="primary"
                            @click="classeSubgrupo(row.item)">
                            <b-icon icon="list-ul" />
                            <b-tooltip :target="row.index + 'classe'" title="Classe..."></b-tooltip>
                        </b-button>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px" v-if="subgrupos.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="load" :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total" @change="loadPage"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
                <modal-page-classe v-if="showModalClasse" @close="cancelar" :prefix="prefix + title + ' > '"
                    :currentSubgrupo="currentSubgrupo" />
                <subgrupo-produto-form v-if="showModalSubgrupoForm" @close="cancelar" @saved="load"
                    :prefix="prefix + title + ' > '" :subgrupo="currentSubgrupo" :currentGrupo="currentGrupo" />
            </b-card>
        </b-card-body>
        <ModaLocalProibidoSubGrupoProduto v-if="mostrarLocalProibido" :prefix="[prefix + title]" :id="id"
            @close="closeMostrarModalProibido" />
    </b-card>
</template>

<script>
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import ConfirmMixin from "@/core/mixins/confirm"
import SubgrupoProdutoForm from "./SubgrupoProdutoForm.vue"
import SubgrupoProdutoService from "@/core/api/SubgrupoProdutoService"
import ModalPageClasse from "@/core/components/Modals/ModalPageClasse.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import ModaLocalProibidoSubGrupoProduto from "@/core/components/Modals/ModaLocalProibidoSubGrupoProduto.vue"
export default {
    name: "SubgrupoProdutoList",
    components: {
        SubgrupoProdutoForm,
        ModalPageClasse,
        ModaLocalProibidoSubGrupoProduto,
        LgFormInput,
        LgFormConstSelect,
    },
    mixins: [ListResourceMixin, ConfirmMixin],

    props: {
        onDblClickSubgrupo: Function,
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Subgrupo Produto",
        },
        currentGrupo: {
            type: Object,
            default: () => null,
        },
        addBtnVisible: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            mostrarLocalProibido: false,
            page: 1,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            total: 0,
            totalPage: 0,
            filtro: "",
            showModalClasse: false,
            showModalSubgrupoForm: false,
            currentSubgrupo: {},
            grupoId: null,
            numeroFmt: "",
            form: {
                descricao: "",
                situacao: 1,
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: null },
                    { key: "filterSituacao", text: "Ativo", value: 1 },
                    { key: "filterSituacao", text: "Inativo", value: 0 },
                ],
            },
            subgrupos: [],
        }
    },

    watch: {
        page() {
            this.load()
        },
    },

    async beforeMount() {
        this.$SubgrupoProdutoService = new SubgrupoProdutoService()
    },

    async mounted() {
        this.load()
    },

    computed: {
        tableFields() {
            return [
                {
                    key: "numeroFmt",
                    label: "Nº",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdStyle: "text-left ",
                },
                {
                    key: "descricao",
                    label: "Descrição",
                    thStyle: "font-size: 16px; ",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "migrarSubgrupo",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },
                {
                    key: "local",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },

                {
                    key: "editar",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },

                {
                    key: "configuracoes",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },
                {
                    key: "situacao",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },

                {
                    key: "classe",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },
            ]
        },
    },

    methods: {
        clickMostrarModalProibido(item) {
            this.id = item.cod;
            this.mostrarLocalProibido = true;
        },
        closeMostrarModalProibido() {
            this.id = null;
            this.mostrarLocalProibido = false;
            this.load();
        },


        temPrivilegioLocalProibido() {
            return verificaPrivilegio(PrivilegiosEnum.ITEM_BEM_PERMANENTE_PODE_INSERIR_LOCAIS_NAO_AUTORIZADOS);

        },
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ALMOXARIFADO_EDITAR);

        },
        temPrivilegioCriacao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ALMOXARIFADO_INCLUIR);

        },
        temPrivilegioAlterarClasse() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ALTERAR_CLASSE_PRODUTO);

        },

        async load() {
            this.filtro = {}
            if (this.form.descricao) {
                this.filtro.descricao = this.form.descricao
            }

            if (this.form.situacao != null) {
                this.filtro.situacao = this.form.situacao
            }
            this.busy = true
            this.grupoId = this.currentGrupo ? this.currentGrupo.id : null
            try {
                let response
                response = await this.$SubgrupoProdutoService.findAll({
                    size: this.perPage,
                    page: this.page,
                    situacao: this.filtro.situacao,
                    descricao: this.filtro.descricao,
                    grupoId: this.grupoId,
                })
                this.subgrupos = response.content.map(subgrupo => ({
                    ...subgrupo,
                    numeroFmt: `${subgrupo.grupoProduto.numero}.${subgrupo.numero}`,
                }))
                this.total = response.totalElements
                this.totalPage = response.totalPages
                this.perPage = response.size
            } catch (error) {
                this.subgrupos = []
            } finally {
                this.busy = false
            }
        },

        loadPage(newPage) {
            this.page = newPage
            this.load()
        },

        showSubgrupoModal() {
            this.showModalSubgrupoForm = true
        },

        subgrupoSelect(subgrupo) {
            this.$emit("onDblClickSubgrupo", subgrupo)
        },

        editarSubgrupo(subgrupo) {
            this.currentSubgrupo = subgrupo
            this.showModalSubgrupoForm = true
        },

        cancelar() {

            this.showModalClasse = false
            this.currentSubgrupo = null
            this.showModalSubgrupoForm = false
            this.load()
        },

        configurarSubgrupo() {
            this.$notify({
                type: "danger",
                message: "Em desenvolvimento...",
            })
        },

        migrarSubgrupo() {
            this.$notify({
                type: "danger",
                message: "Em desenvolvimento...",
            })
        },

        classeSubgrupo(subgrupo) {
            this.currentSubgrupo = subgrupo;
            this.showModalClasse = true;
        },

        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " o Grupo?",
                item.descricao.toUpperCase()
            )
            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacao = item.situacao == 1 ? 0 : 1
            }
        },

        async confirmarAlteracaoSituacao(item) {
            const { status } = await this.$SubgrupoProdutoService.alteraSituacao(item)
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
                        } o registro!`,
                })
            }
        },
    },
}
</script>
